var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _onSectionsToUpdateListener, _handleCartUpdate, _CartEmpty_instances, onSectionsToUpdate_fn;
import { C as Component, k as CustomEvents, D as DiscountUpdateEvent, s as sectionRenderer, m as morphSection } from "./utilities-Da0sjanJ.js";
class CartEmpty extends Component {
  constructor() {
    super();
    __privateAdd(this, _CartEmpty_instances);
    __privateAdd(this, _onSectionsToUpdateListener);
    __privateAdd(this, _handleCartUpdate, (event) => {
      var _a;
      if (event instanceof DiscountUpdateEvent) {
        sectionRenderer.renderSection(this.sectionId, { cache: false });
        return;
      }
      if (event.target === this) return;
      const cartEmptyHtml = (_a = event.detail.data.sections) == null ? void 0 : _a[this.sectionId];
      if (cartEmptyHtml) {
        morphSection(this.sectionId, cartEmptyHtml);
      } else {
        sectionRenderer.renderSection(this.sectionId, { cache: false });
      }
    });
    __privateSet(this, _onSectionsToUpdateListener, __privateMethod(this, _CartEmpty_instances, onSectionsToUpdate_fn).bind(this));
  }
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CustomEvents.cartUpdate, __privateGet(this, _handleCartUpdate));
    document.addEventListener(CustomEvents.discountUpdate, __privateGet(this, _handleCartUpdate));
    document.addEventListener(CustomEvents.cartSectionsToUpdate, __privateGet(this, _onSectionsToUpdateListener));
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CustomEvents.cartUpdate, __privateGet(this, _handleCartUpdate));
    document.removeEventListener(CustomEvents.discountUpdate, __privateGet(this, _handleCartUpdate));
    document.removeEventListener(CustomEvents.cartSectionsToUpdate, __privateGet(this, _onSectionsToUpdateListener));
  }
  get sectionId() {
    const { sectionId } = this.dataset;
    if (!sectionId) throw new Error("Section id missing");
    return sectionId;
  }
}
_onSectionsToUpdateListener = new WeakMap();
_handleCartUpdate = new WeakMap();
_CartEmpty_instances = new WeakSet();
onSectionsToUpdate_fn = function(event) {
  const { sections } = event.detail || {};
  if (!sections) return;
  sections.push(this.sectionId);
};
if (!customElements.get("cart-empty")) {
  customElements.define("cart-empty", CartEmpty);
}
